import React from "react";
import Typography from "@material-ui/core/Typography";

export const JoiningMissions = ({ refProp }) => {
  return (
    <div ref={refProp}>
      <Typography variant="h3" component="h2">
        <u>Joining a Mission</u>
      </Typography>
      <p>
        We run COOP missions every Sunday and Saturday, as well as an alternate
        event on Friday.
      </p>
      <p>
        Signing up for these missions just involves joing the discord and
        slotting in! (More info further down) Be sure to show up on TS and the
        game server in time and don't be afraid to ask an Officer or Moderator
        for help!
      </p>
      <p>
        To get an idea of how we play at CA, you can read our CA Infantryman's
        Primer. This covers the basics you need to know as a new player.
      </p>
    </div>
  );
};

export default JoiningMissions;
